;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { LocalesWithPaths } from '../../config';

export const menu = [
  {
    name: 'your-career',
    destination: '/',
    subMenu: [
      {
        name: 'vacancies',
        destination: '/jobs',
        internal: true,
        topMenu: 0,
        footer: 0,
      },
      {
        name: 'blog',
        destination: '/blog',
        internal: true,
        topMenu: 1,
        footer: 1,
      },
    ],
    topMenu: 0,
    footer: 1,
  },
  {
    name: 'companies',
    destination: '/employer',
    subMenu: [
      {
        name: 'recruitment',
        destination: '/employer/recruitment',
        internal: true,
        topMenu: 0,
        footer: 0,
      },
      {
        name: 'testing',
        destination: '/employer/testing',
        internal: true,
        topMenu: 1,
        footer: 1,
      },
      {
        name: 'outsourcing',
        destination: '/employer/outsourcing',
        internal: true,
        topMenu: 2,
        footer: 2,
      },
      {
        name: 'blog',
        destination: '/employer/blog',
        internal: true,
        topMenu: 3,
        footer: 3,
      },
    ],
    topMenu: 1,
    footer: 2,
  },
  {
    name: 'about',
    destination: '/about',
    subMenu: [
      {
        name: 'team',
        destination: '/about/team',
        internal: true,
        topMenu: 0,
        footer: 1,
      },
      {
        name: 'working',
        destination: '/about/working',
        internal: true,
        topMenu: 1,
        footer: 2,
      },
      {
        name: 'synergie-belgium',
        destination: 'https://www.synergiejobs.be/nl/about/',
        internal: false,
        topMenu: -1,
        footer: 3,
      },
    ],
    topMenu: 2,
    footer: 0,
  },
  {
    name: 'international',
    destination: '#',
    subMenu: [
      {
        name: 'footer_sandyou_france',
        destination: 'https://www.sandyou.fr/',
        internal: false,
        topMenu: -1,
        footer: 0,
      },
      {
        name: 'footer_sandyou_spain',
        destination: 'https://www.sandyou.es/',
        internal: false,
        topMenu: -1,
        footer: 1,
      },
      {
        name: 'footer_sandyou_germany',
        destination: 'https://www.sandyou.de/',
        internal: false,
        topMenu: -1,
        footer: 2,
      },
      {
        name: 'footer_sandyou_italy',
        destination: 'https://www.sandyou.it/',
        internal: false,
        topMenu: -1,
        footer: 3,
      },
      {
        name: 'footer_sandyou_portugal',
        destination: 'https://www.sandyou.pt/',
        internal: false,
        topMenu: -1,
        footer: 4,
      },
      {
        name: 'footer_sandyou_suisse',
        destination: 'https://www.sandyou.ch/',
        internal: false,
        topMenu: -1,
        footer: 5,
      },
      {
        name: 'footer_sandyou_austria',
        destination: 'https://www.sandyou.at/',
        internal: false,
        topMenu: -1,
        footer: 6,
      },
      {
        name: 'footer_sandyou_australia',
        destination: 'https://www.sandyou.com.au/',
        internal: false,
        topMenu: -1,
        footer: 7,
      },
      {
        name: 'footer_sandyou_canada',
        destination: 'https://www.sandyou.ca/fr/',
        internal: false,
        topMenu: -1,
        footer: 8,
      },
      {
        name: 'footer_sandyou_czech_rep_slovakia',
        destination: 'https://www.sandyou.sk/cs/',
        internal: false,
        topMenu: -1,
        footer: 9,
      },
      {
        name: 'footer_sandyou_poland',
        destination: 'https://www.sandyou.pl/',
        internal: false,
        topMenu: -1,
        footer: 10,
      },
      {
        name: 'footer_sandyou_uk',
        destination: 'https://www.sandyou.co.uk/',
        internal: false,
        topMenu: -1,
        footer: 11,
      },
    ],
    topMenu: -1,
    footer: 3,
  },
];

export const legals = [
  {
    name: 'footer-privacy-cookies',
    destination: '/legal/privacy',
    internal: true,
  },
  {
    name: 'footer_link_termsandconditions',
    destination: '/legal/termsandconditions',
    internal: true,
  },
  {
    name: 'footer-integrity-platform',
    destination: 'https://synergie.integrityline.com',
    internal: false,
  },
  {
    name: 'footer_commercial_terms',
    destination: '/legal/termsofuse',
    internal: true,
  },
  {
    name: 'footer-registration-numbers',
    destination: '/legal/registrationnumbers',
    internal: true,
  },
  {
    name: 'footer-gdpr-form',
    destination: '/legal/rights-request',
    internal: true,
  },
  {
    name: 'footer-ethical-code',
    destination: '/legal/ethicalcode',
    internal: true,
  },
];

// The topbar and footer will always base themselves on the path to switch languages (using the default locales in config.ts)...
// If this needs to be changed for some reason, you can add the pathname to this object and an array of all the locales with the right destination
export const deviantLocales: { [key: string]: LocalesWithPaths } = {};
